<div class="subHeader" *ngIf="showMe">
  <div class="row">
    <div *ngIf="!isDemo" [ngClass]="{'taller': readyToSend || readyToSign}" class="col col-sm-3 mini-portal-link">
      <div class="fake-anchor" (click)="backToMiniPortal()" onkeypress="backToMiniPortal()">
        {{ this.userRole === 'Agent' ? 'Application Portal' : this.userRole === 'Omnipotent' ? 'Debug Page' : null }}
      </div>
    </div>
    <div class="col col-sm-9 send-app-btn row" *ngIf="readyToSend">
      <button class="btn send-button" (click)="triggerModal()">
        <div class="send-button-text">Send application to proposed insured</div>
      </button>
    </div>
    <div class="col col-sm-9 send-app-btn row" *ngIf="readyToSign">
      <button class="btn send-button" (click)="goSign()">
        <div class="send-button-text">
          <ng-container *ngIf="userRole !== 'Agent' && !customerSigned">Your application is ready to sign</ng-container>
          <ng-container *ngIf="userRole !== 'ProposedInsured' && customerSigned">This application is ready to finalize</ng-container>
        </div>
      </button>
    </div>
  </div>
</div>
